import { render } from "./TheVehicleTypesVehicles.vue?vue&type=template&id=3141f89a"
import script from "./TheVehicleTypesVehicles.vue?vue&type=script&lang=js"
export * from "./TheVehicleTypesVehicles.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__